<div class="iconized-button">
    <button class="mat-button" (click)='editPostcodeAction()'>
    <i class="material-icons">edit</i> Edit</button>
    <button class="mat-button" (click)="deletePostcodeAction()">
    <i class="material-icons">clear</i> Delete</button></div>